import { AxiosResponse } from "axios";
import API from "../api";

import { Destination } from "../models/destination";

const endpoint = "destinations/inventorys";

const DestinationService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Destination[]>> {
    return await API.get(`/${endpoint}`, { params: options });
  },
  async create(destination: Destination): Promise<AxiosResponse<Destination>> {
    return await API.post(`/${endpoint}`, destination);
  },
  async update(id: number, destination: Destination): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/${id}`, destination);
  },
};

export default DestinationService;
